module.exports = __webpack_public_path__ + "img/h源端治理.9c04c04c.svg";